export default "__VITE_ASSET__CvQpbDLz__"